<template>
  <div class="modal-wrapper">
    <button class="modal-close button button--filter" @click="closeModal">
      <i class="fas fa-times"></i>
    </button>

    <div class="modal-container modal-container--transparent modal-container--large">
      <div>
        <p class="title title--1 title--white">
          {{ $t(title) }}
        </p>
      </div>

      <div class="modal-body">
        <div class="modal-body__section">
          <p>{{ $t(content) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    content: {
      type: String,
      default: null,
    },
  },
  methods: {
    closeModal() {
      this.$emit('closeModal');
    },
  },
};
</script>
